// Enums
export enum GeospatialColourType {
    METRIC_COLOUR1 = 'METRIC_COLOUR1',
    METRIC_COLOUR2 = 'METRIC_COLOUR2',
    METRIC_COLOUR3 = 'METRIC_COLOUR3',
    METRIC_COLOUR4 = 'METRIC_COLOUR4',
    METRIC_COLOUR5 = 'METRIC_COLOUR5',
    METRIC_ALT_COLOUR1 = 'METRIC_ALT_COLOUR1',
    METRIC_ALT_COLOUR2 = 'METRIC_ALT_COLOUR2',
    METRIC_ALT_COLOUR3 = 'METRIC_ALT_COLOUR3',
    METRIC_ALT_COLOUR4 = 'METRIC_ALT_COLOUR4',
    METRIC_ALT_COLOUR5 = 'METRIC_ALT_COLOUR5',
    OUTAGE_COLOUR1 = 'OUTAGE_COLOUR1',
    OUTAGE_COLOUR2 = 'OUTAGE_COLOUR2',
    OUTAGE_COLOUR3 = 'OUTAGE_COLOUR3',
    OUTAGE_COLOUR4 = 'OUTAGE_COLOUR4',
    OUTAGE_COLOUR5 = 'OUTAGE_COLOUR5',
    PROJECT_SCOPE = 'PROJECT_SCOPE',
    PROJECT_PROJECT = 'PROJECT_PROJECT',
    PROJECT_BUILT = 'PROJECT_BUILT',
    PROJECT_GENERATED = 'PROJECT_GENERATED',
    BLUE = 'BLUE',
    GREY = 'GREY',
    NONE = 'NONE',
}
